// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"7ae713c18a7cde5f2c1f","678":"7ac3b5414a5339119ab3","883":"c23681dc5fcc00f8f7b4"}[chunkId] + ".js";
};